resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
  Slider

  Slider widget that can swipe or rotate slides. Slide names are added as data attributes to each slide which are consumed by analytics on each slide view.
  This slider uses the Swiper library. More documentation including options, methods, and events can be found at http://idangero.us/swiper/api/.

  HTML structure:
  All class names below are required.

  .swiper-container(data-mogo-ui="Slider")
      .swiper-wrapper
          .swiper-slide(data-pagename="slide-1")= "Slide 1"
          .swiper-slide(data-pagename="slide-2")= "Slide 2"
          .swiper-slide(data-pagename="slide-3")= "Slide 3"
      .swiper-pagination
      .swiper-button-prev
      .swiper-button-next
*/
function Slider() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_ScrollingLayout];

  // internal variables
  this._slider = null;
  this._currentSlide = -1;

  this.init = function () {
    this.$node = $(this.node);
    $(this.node).addClass('show');
    this._setupAnalytics();
  };

  this.initAllReady = function () {
  };

  this.initSwiper = function () {
    this._slider = new Swiper('.swiper-container', {
      pagination: {
        el: '.swiper-pagination'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      init: false
    });
    this._bindSliderEvents();
    this._slider.init();
  };

  this._bindSliderEvents = function () {
    this._currentSlide = 0;

    this._slider.on('init', function () {
      this._pushSliderAnalytics();
    }.bind(this));
    this._slider.on('slideChange', function () {
      this._currentSlide = this._slider.activeIndex;
      this._pushSliderAnalytics();
    }.bind(this));
  };

  this._setupAnalytics = function () {
    this.analytics = new Analytics();
  };

  this._pushSliderAnalytics = function () {
    if (this._slider.slides && this._slider.slides.length && this._slider.slides.length > this._currentSlide) {
      if (!this._slider.slides[this._currentSlide].dataset) {
        console.warn('No pagename data attribute specified for this slide');
        return false;
      }

      var currentSlideName = this._slider.slides[this._currentSlide].dataset.pagename;
      var url = window.location.href + '/' + currentSlideName;
      this.analytics.pushEvent('virtual-page-view', {Page: [url]});
    }
  };
}
